export default __webpack_public_path__ + "static/3isp-ce3936aed4e71e51ed4564469b2eebf2.gif";